/**
 * 获取sos信息
 */
 import grpc from '@/libs/grpc'
 import GpsGetSOSPb from '@/proto/sos/GpsGetSOS_pb.js'
 import GpsGetSOSPbService from '@/proto/sos/GpsGetSOS_pb_service.js'

  /**
   * 获取sos信息
   * @param {*} reqBase 
   * @returns 
   */
  export function GpsGetSOS (reqBase,prefix) {
    console.log(reqBase,prefix)
   const req = new GpsGetSOSPb.Req()
   req.setToken(reqBase.token)
   return grpc.invoke(GpsGetSOSPbService.PPRpc.PCall, req,prefix)
 }
 